import React, { ReactElement } from "react";
import { Navigate, RoutesProps } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";

interface AuthGuardProps extends RoutesProps {
  children: ReactElement;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { isAuthenticated, user } = useSelector((state: RootState) => state.auth);

  // If the user is authenticated and does NOT need to change password (force_change_password is truthy),
  // route away from auth pages (login) to the app root. If the user must change password (force_change_password
  // is null/false), allow the auth page to render so the login -> change-password navigation can complete.
  if (isAuthenticated && user?.force_change_password) {
    return <Navigate to="/" />;
  }

  return children;
};

export default AuthGuard;
